import React from "react";
import {
  Settings2, Wrench, ClipboardCheck, Search, TrendingUp, Cog, Users, ShieldCheck,
  Lightbulb, Car, Factory, Building2, Recycle, Milk, FlaskConical, Package, Zap,
  MoreHorizontal, Eye, Handshake, Target, Leaf, BarChart3, Truck, Rocket, Globe,
  Star, GitBranch, MapPin,
} from "lucide-react";

const MAP = {
  Settings2, Wrench, ClipboardCheck, Search, TrendingUp, Cog, Users, ShieldCheck,
  Lightbulb, Car, Factory, Building2, Recycle, Milk, FlaskConical, Package, Zap,
  MoreHorizontal, Eye, Handshake, Target, Leaf, BarChart3, Truck, Rocket, Globe,
  Star, GitBranch, MapPin,
};

export const Icon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Cog;
  return <Cmp {...props} />;
};

export default Icon;
